import { Component, Input } from '@angular/core';
import { Models } from '@ibexfusion/models'
import moment from 'moment';
import * as _ from 'lodash';

@Component({
    selector: 'dynamic-content-table-active-state',
    templateUrl: './dynamic-content-table-active-state.component.html',
    styleUrls: ['./dynamic-content-table-active-state.component.scss'],
    standalone: false
})
export class DynamicContentTableActiveStateComponent {
  @Input() item: any;
  @Input() app: Models.PackageInstalledApp;

  checkActiveState(element) {
    let state = 'active';
    if (!!element?.content?.finished) {
      state = 'finished';
    } else if (!element?.published) {
      state = 'disabled';
    } else {
      const now = new Date();

      if (!this.weekdaysValid(element?.weekdaysInterval)) {
        state = 'paused';
      } else {
        element.publishStart = this.cleanUpDate(element?.publishStart);
        element.publishEnd = this.cleanUpDate(element?.publishEnd);

        try {
          const val = !!element.publishStart && element.publishStart.getTime() > now.getTime() || !!element.publishEnd && element.publishEnd.getTime() < now.getTime();
        } catch (err) {
          console.warn(element, err)
        }
        if (
          !!element.publishStart && (element.publishStart?.getTime ? element.publishStart.getTime() : element.publishStart) > now.getTime()
          || !!element.publishEnd && (element.publishEnd?.getTime ? element.publishEnd.getTime() : element.publishEnd) < now.getTime()
        ) {
          state = 'paused';
        } else {
          if (!!element.publishStartTime && this.sameDay(now, element.publishStart)) {
            const tfs = element.publishStartTime.split(':');
            if (+tfs[0] > now.getHours() || +tfs[0] === now.getHours() && +tfs[1] > now.getMinutes()) {
              state = 'paused';
            }
          }
          if (!!element.publishEndTime && this.sameDay(now, element.publishEnd)) {
            const tff = element.publishEndTime.split(':');
            if (+tff[0] < now.getHours() || +tff[0]  === now.getHours() && +tff[1] < now.getMinutes()) {
              state = 'paused';
            }
          }
        }
      }
    }
    if (state === 'active' && element.type === 'activity') {
      state = this.calculateNextExecution(element?.content || element) && !this.calculateNextExecution(element?.content || element)?.isSameOrAfter(moment().startOf('week')) ? 'paused' : state;
    } else if (state === 'active' && element.type === 'gastronomy') {
      let useItem = false;
      if (element.children?.length) {
        for (const child of element.children) {
          if (moment(child.content.date).isSameOrAfter(moment().startOf('day'))) {
            useItem = true;
          }
        }
      } else if (moment(element.content.date).isSameOrAfter(moment().startOf('day'))) {
        useItem = true;
      }
      if (!useItem) {
        state = 'paused';
      }
    } else if (state === 'active' && element.type === 'event') {
      state = this.checkEventDate(element.content) ? state : 'paused';
    } else if (state === 'active' && element.type === 'voucher' && element?.content?.expirationDate) {
      state = moment(element.content.expirationDate).isSameOrBefore(moment().startOf('day')) ? 'paused' : state;
    }
    return state;
  }

  public calculateNextExecution(content: any) {
    const todayMom = moment();
    if (content.repeating) {
      const mom = moment(content.date || undefined);
      switch (content.rhythm) {
        case 'weekly':
          while (content.weekdays.indexOf(todayMom.weekday()) === -1) {
            todayMom.add(1, 'day');
          }
          break;
        case 'monthly':
          if (mom.date() < todayMom.date()) {
            todayMom.add(1, 'month');
          }
          todayMom.date(mom.date());
          break;
        case 'yearly':
          if (mom.isBefore(todayMom, 'day')) {
            todayMom.add(1, 'year');
          }
          todayMom.month(mom.month()).date(mom.date());
      }
      return todayMom;
    }
    return content.date ? moment(content.date) : null;
  }

  private checkEventDate(content): boolean {
    if (content?.repeating) {
      let dates = this.getNextExecutionDateRepeating(content);
      const today = new Date();
      today.setHours(0,0,0,0);
      dates = dates.filter(date => date.getTime() >= today.getTime());
      return !!dates?.length
    } else if (content?.validity && !content.multipleDates) {
      return this.checkValidDate(content?.validity?.start, content?.validity?.end);
    } else if (content?.dates) {
      if (!_.isArray(content.dates)) {
        content.dates = [content.dates];
      } else if (content.dates.length <= 0) {
        return true;
      }

      const eventDates = content.multipleDates ? content.multipleDates : content.dates;

      let validDate = false;
      for (const date of eventDates) {
        if (date.daily === undefined) { /* what is daily for - why do we exclude it here ? */
          continue;
        }
        const startDate = this.getDateUnix(date.startDate);
        const endDate = this.getDateUnix(date.endDate, true);
        validDate = (!startDate && !endDate) || this.checkValidDate(startDate, endDate);
      }
      return validDate;
    }
    return false;
  }

  getNextExecutionDateRepeating(event: any) {
    let endDate = !!event?.repetition?.endDate ? new Date(event.repetition.endDate) : null;
    if (!endDate) {
      endDate = new Date();
      endDate.setFullYear(endDate.getFullYear() + 1);
    }
    if (this.app?.detail?.publicationTimespan) {
      let d = new Date();
      if (this.app.detail.publicationTimespan.days) {
        d.setDate(d.getDate() + this.app.detail.publicationTimespan.days);
        endDate = d;
      } else if (this.app.detail.publicationTimespan.months != null) {
        d.setMonth(d.getMonth() + this.app.detail.publicationTimespan.months);
        endDate = new Date(d.getFullYear(), d.getMonth() + 1, 0);
      }
    }
    endDate.setHours(23, 59, 59, 999);
    let date = new Date(event.repetition.startDate);
    const nth = this.getWeekdayOccurrence(date);
    const day = date.getDay();
    const dates = [];
    dates.push(new Date(date));
    if (event.repetition.repetitionSize === 'day') {
      if (event.repetition.repetitionRhythm === '1') {
        date.setDate(date.getDate() + 1);
        while (date.getTime() < endDate.getTime()) {
          if (event.repetition.weekdays.includes(date.getDay().toString()) || event.repetition.weekdays.includes(date)) {
            dates.push(new Date(date));
          }
          date.setDate(date.getDate() + 1);
        }
      } else {
        date.setDate(date.getDate() + parseInt(event.repetition.repetitionRhythm));
        while (date.getTime() < endDate.getTime()) {
          dates.push(new Date(date));
          date.setDate(date.getDate() + parseInt(event.repetition.repetitionRhythm));
        }
      }
    } else if (event.repetition.repetitionSize === 'week') {
      const date = this.getMonday(event.repetition.startDate);
      while (date.getTime() < endDate.getTime()) {
        for (let i = 0; i < 7; i++) {
          if (date.getTime() < new Date(event.repetition.startDate).getTime()) {
            date.setDate(date.getDate() + 1);
            continue;
          }
          if (event.repetition.weekdays.includes(date.getDay().toString()) || event.repetition.weekdays.includes(date.getDay())) {
            dates.push(new Date(date));
          }
          date.setDate(date.getDate() + 1);
          if (i === 6) {
            date.setDate(date.getDate() + ((parseInt(event.repetition.repetitionRhythm) - 1) * 7));
          }
        }
      }
    } else if (event.repetition.repetitionSize === 'month') {
      if (event.repetition.repetitionLastDay) {
        while (date.getTime() < endDate.getTime()) {
          date.setDate(1);
          date.setMonth(date.getMonth() + parseInt(event.repetition.repetitionRhythm, 10) + 1);
          date.setDate(0);
          dates.push(new Date(date));
        }
      } else if (event.repetition.repetitionExact) {
        while (date.getTime() < endDate.getTime()) {
          dates.push(new Date(date));
          date.setDate(date.getDate() + this.getDaysInMonth(date));
        }
      } else {
        while (date.getTime() < endDate.getTime()) {
          dates.push(new Date(date));
          date = this.getNthWeekdayOfNextMonth(date, day, nth);
        }
      }
    } else if (event.repetition.repetitionSize === 'year') {
      if (event.repetition.repetitionExact) {
        while (date.getTime() < endDate.getTime()) {
          dates.push(new Date(date));
          date = new Date(date.getFullYear() + 1, date.getMonth(), date.getDate())
        }
      } else {
        while (date.getTime() < endDate.getTime()) {
          dates.push(new Date(date));
          for (let i = 0; i < 12; i++) {
            date = this.getNthWeekdayOfNextMonth(date, day, nth);
          }
        }
      }
    }
    return dates;
  }

  getMonday(date) {
    const currentDate = new Date(date);
    const dayOfWeek = currentDate.getDay();
    const diff = (dayOfWeek === 0) ? -6 : 1 - dayOfWeek;
    currentDate.setDate(currentDate.getDate() + diff);
    currentDate.setHours(0, 0, 0, 0);
    return currentDate;
  }

  getDaysInMonth(date) {
    const year = date.getFullYear();
    const month = date.getMonth();
    return new Date(year, month + 1, 0).getDate();
  }

  getWeekdayOccurrence(date) {
    const currentDate = new Date(date);
    currentDate.setDate(1);
    const firstOccurrence = 1 + ((date.getDay() - currentDate.getDay() + 7) % 7);
    return Math.floor((date.getDate() - firstOccurrence) / 7) + 1;
  }

  getNthWeekdayOfNextMonth(currentDate, targetWeekday, targetOccurrence) {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstOfNextMonth = new Date(year, month + 1, 1);
    const firstWeekday = firstOfNextMonth.getDay();
    const dayDiff = (targetWeekday - firstWeekday + 7) % 7;
    const firstTargetWeekday = 1 + dayDiff;
    const dayOfMonth = firstTargetWeekday + (targetOccurrence - 1) * 7;
    return new Date(year, month + 1, dayOfMonth);
  }

  private checkValidDate(startDate, endDate) {
    // (contentEntry.detail.validity && ((contentEntry.detail.validity.end && this.today > contentEntry.detail.validity.end))));
    if (endDate && this.getNulledDate() > endDate) { // event already in past (with endDate)
      return false;
    }
    if (!endDate && this.getNulledDate() > startDate) { // event already in past (without endDate)
      return false;
    }
    return true;
  }

  private getNulledDate() {
    const date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date.getTime() / 1000;
  }

  private getDateUnix(dateString, isEndDate = false) {
    const res = this.getDate(dateString, isEndDate);
    return !!res ? res.getTime() / 1000 : null;
  }

  private getDate(dateString, isEndDate = false) {
    let res = null;
    if (!!dateString) {
      if (/\d?\d\.\d?\d\.(\d\d|\d\d\d\d)/.test(dateString)) {
        const dateParts = dateString.split('.');
        res = new Date(dateParts[1] + '/' + dateParts[0] + '/' + dateParts[2]);
        if (isEndDate) {
          res.setHours(23);
          res.setMinutes(59);
          res.setSeconds(59);
        }
      } else {
        res = new Date(dateString);
      }
    }
    return res;
  }

  private weekdaysValid(weekdays): boolean {
    if (weekdays === null || weekdays === undefined) {
      return true;
    }

    const days = [];
    if (!_.isArray(weekdays)) {
      weekdays = _.values(weekdays);
    }

    for (const weekday of weekdays) {
      days[weekday] = true;
    }

    return days[new Date().getDay()];
  }

  private sameDay(d1, d2) {
    if (d1 && d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
    } else {
      return false;
    }
  }

  private cleanUpDate(d) {
    if (!!d && typeof d === 'string') { // convert value for new dynamic-content
      if (/\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d\d.\d\d\d/gm.test(d)) {
        d = new Date(d).getTime() / 1000;
      }
    }
    if (!!d && typeof d === 'number') {
      d = new Date(d > 1e12 ? d : d * 1000);
    }
    return d;
  }
}
